import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Container, Menu, Segment, Button, Dropdown } from 'semantic-ui-react'
import { withTranslation } from 'react-i18next'
import { Link } from 'gatsby'
import { urlSchema } from '../../urlSchema'

class DesktopContainer extends Component {
  constructor(props) {
    super(props)
    this.state = { fixed: true }
  }

  hideFixedMenu = () => this.setState({ fixed: true })

  showFixedMenu = () => this.setState({ fixed: true })

  render() {
    const { children, t, i18n } = this.props
    const { fixed } = this.state

    let helpdeskUrl = 'https://help.speisekammer-app.de/en/'
    if (i18n.language.startsWith('de')) {
      helpdeskUrl = 'https://help.speisekammer-app.de/de/'
    }

    // eslint-disable-next-line no-return-assign
    return (
      <>
        <Segment inverted textAlign="center" style={{ paddingBottom: '1.7em' }}>
          <Menu
            fixed={fixed ? 'top' : null}
            inverted={!fixed}
            pointing={!fixed}
            secondary={!fixed}
            size="large"
          >
            <Container>
              <Menu.Item as={Link} to="/" activeClassName="active">
                {t('menu.home')}
              </Menu.Item>
              <Dropdown item text={t('menu.features.link')}>
                <Dropdown.Menu>
                  {/*
                    <Dropdown.Item
                      as={Link}
                      to={urlSchema.forFamilies[i18n.language]} // icon="edit"
                      text={t('menu.features.families.link')}
                      activeClassName="active"
                    />
                    <Dropdown.Item
                      as={Link}
                      to={urlSchema.forHobbyChefs[i18n.language]}
                      text={t('menu.features.amateurChefs.link')}
                      activeClassName="active"
                    />
                    <Dropdown.Item
                      as={Link}
                      to={urlSchema.forSharedApartments[i18n.language]}
                      text={t('menu.features.sharedApartments.link')}
                      activeClassName="active"
                    />
                    <Dropdown.Item
                      as={Link}
                      to={urlSchema.forEcologicallyAware[i18n.language]}
                      text={t('menu.features.ecologicallyAware.link')}
                      activeClassName="active"
                    />
                    */}
                  <Dropdown.Item
                    as={Link}
                    to={urlSchema.forPreppers[i18n.language]}
                    text={t('menu.features.preppers.link')}
                    activeClassName="active"
                  />
                </Dropdown.Menu>
              </Dropdown>
              <Menu.Item as="a" href={helpdeskUrl}>
                {t('menu.faq')}
              </Menu.Item>
              <Menu.Item as={Link} to={urlSchema.about[i18n.language]} activeClassName="active">
                {t('menu.about')}
              </Menu.Item>

              {i18n.language.startsWith('de') && (
                <Menu.Item as={Link} to="/blog/" activeClassName="active">
                  {t('menu.blog')}
                </Menu.Item>
              )}
              <Menu.Item as={Link} to={urlSchema.pricing[i18n.language]} activeClassName="active">
                {t('menu.pricing')}
              </Menu.Item>

              <Menu.Item position="right">
                <Button
                  as="a"
                  color="yellow"
                  href="https://app.speisekammer-app.de/login"
                  inverted={!fixed}
                >
                  {t('header.button.login')}
                </Button>
                {/* <Button
                    inverted={!fixed}
                    as={Link}
                    to={urlSchema.pricing[i18n.language]}
                    color="yellow"
                    style={{ marginLeft: '0.5em' }}
                  > */}
                <Button
                  as="a"
                  inverted={!fixed}
                  href="https://app.speisekammer-app.de/signup"
                  color="yellow"
                  style={{ marginLeft: '0.5em' }}
                >
                  {t('header.button.signUp')}
                </Button>
              </Menu.Item>
            </Container>
          </Menu>
        </Segment>
        {children}
      </>
    )
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node.isRequired,
  t: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
}

export default withTranslation()(DesktopContainer)
